<template>
	<div v-if="state === 'billing'">
		<v-progress-linear :indeterminate="loading" v-if="loading" />
		<div class="hp-100 py-2 d-flex flex-column justify-space-between">
			<v-expansion-panels v-model="expandedPanels" style="gap: 8px">
				<v-expansion-panel>
					<v-expansion-panel-header style="height: 85px">
						<div>RPM</div>
						<div class="my-0 py-0">
							<template>
								<v-row>
									<v-col class="d-flex justify-end align-center py-1 text-center" cols="12">
										<span class="d-flex align-start font-weight-bold font-size12-5">CPT</span>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt99453"
											:color="checkColor(billingSummary.cpt99453)">
											<div class="d-flex flex-column">
												<span>99453</span>
												<div>{{ billingSummary.cpt99453 }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt99445"
											:color="checkColor(billingSummary.cpt99445)">
											<div class="d-flex flex-column">
												<span>99445</span>
												<div>{{ billingSummary.cpt99445 }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt99454"
											:color="checkColor(billingSummary.cpt99454)">
											<div class="d-flex flex-column">
												<span>99454</span>
												<div>{{ billingSummary.cpt99454 }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt99470"
											:color="checkColor(billingSummary.cpt99470)">
											<div class="d-flex flex-column">
												<span>99470</span>
												<div>{{ billingSummary.cpt99470 }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt99457"
											:color="checkColor(billingSummary.cpt99457)">
											<div class="d-flex flex-column">
												<span>99457</span>
												<div>{{ billingSummary.cpt99457 }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12-5 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt994581st"
											:color="checkColor(billingSummary.cpt994581st)">
											<div class="d-flex flex-column">
												<span> 99458 1st</span>
												<div>{{ billingSummary.cpt994581st }}%</div>
											</div>
										</v-progress-circular>
										<v-progress-circular
											class="font-size12 mx-2 font-weight-bold"
											:rotate="-90"
											:size="75"
											:width="3"
											:value="billingSummary.cpt994582nd"
											:color="checkColor(billingSummary.cpt994582nd)">
											<div class="d-flex flex-column">
												<span>99458 2nd</span>
												<div>{{ billingSummary.cpt994582nd }}%</div>
											</div>
										</v-progress-circular>
									</v-col>
								</v-row>
							</template>
						</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row dense>
							<v-col class="px-0 pb-0" cols="12">
								<v-data-table
									v-if="['SYSTEM_ADMIN', 'SYSTEM_USER', 'ORGANIZATION_ADMIN'].includes(roleName)"
									:items="groupBillings(true, false)"
									item-key="hospitalId"
									single-expand
									:headers="rpmHospitalHeaders"
									fixed-header
									:height="pageHeight(-94)"
									:items-per-page="-1"
									:no-data-text="$t('no-data-available')"
									:loading-text="$t('loading')"
									dense
									class="mx-0 px-0 data-table-outline">
									<template #item="{ item, expand, isExpanded, index }">
										<tr
											:class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]"
											@click="expand(!isExpanded)">
											<td class="font-weight-bold" style="width: 350px">
												<div class="d-flex justify-space-between align-center">
													<span>{{ item.hospitalName }}</span>
													<v-chip class="white--text" pill x-small color="primary">
														{{ item.billings.length }}
													</v-chip>
												</div>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99453"
													:color="getHospitalSummary(item.hospitalId).percent99453 >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent99453 >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99453 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99445"
													:color="getHospitalSummary(item.hospitalId).percent99445 >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent99445 >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99445 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99454"
													:color="getHospitalSummary(item.hospitalId).percent99454 >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent99454 >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99454 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99470"
													:color="getHospitalSummary(item.hospitalId).percent99470 >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent99470 >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99470 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99457"
													:color="getHospitalSummary(item.hospitalId).percent99457 >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent99457 >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99457 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent994581st"
													:color="getHospitalSummary(item.hospitalId).percent994581st >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent994581st >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent994581st }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent994582nd"
													:color="getHospitalSummary(item.hospitalId).percent994582nd >= 100 ? 'green' : 'primary'"
													:class="getHospitalSummary(item.hospitalId).percent994582nd >= 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent994582nd }}%
												</v-progress-linear>
											</td>
											<td class="text-right" style="width: 40px">
												<v-icon color="primary">
													{{ isExpanded ? 'mdi-menu-up' : 'mdi-menu-down' }}
												</v-icon>
											</td>
										</tr>
									</template>
									<template #expanded-item="{ item: hospital }">
										<td class="pa-3 billings-border-bottom" colspan="9">
											<v-data-table
												:items="hospital.billings"
												item-key="patientData.id"
												class="data-table-outline"
												:headers="rpmPatientHeaders"
												fixed-header
												hide-default-footer
												:items-per-page="-1"
												:no-data-text="$t('no-data-available')"
												:loading-text="$t('loading')"
												:height="pageHeight(-174)"
												dense>
												<template #item="{ item, index }">
													<tr
														:class="getRowsForDataTable(index)"
														@click="
															selectedBillingList = hospital;
															selectedBillingIndex = index;
															showDetailsDialog = true;
														">
														<td class="text-left truncate-text" style="max-width: 200px !important">
															<v-icon
																class="mr-1 mdi"
																:class="
																	item.patientData.isRpmEnabled ||
																	item.patientData.isRtmEnabled ||
																	item.patientData.isCcmEnabled
																		? 'mdi-checkbox-blank'
																		: 'mdi-checkbox-blank-outline'
																"
																color="primary" />
															<span class="table-font-size">
																{{ item.patientName }}
															</span>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.cptCode99453?.status === 1 ? 100 : 0"
																:color="item.cptCode99453?.status === 1 ? 'green' : 'primary'"
																:class="item.cptCode99453?.status === 1 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																<template>
																	<v-icon size="16" v-if="item.cptCode99453?.status === 1" color="black">
																		mdi-checkbox-blank
																	</v-icon>
																	<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
																</template>
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent99445"
																:color="item.myBillings?.percent99445 === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent99445 === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																<template>
																	<v-icon size="16" v-if="item.cptCode99445?.status === 1" color="black">
																		mdi-checkbox-blank
																	</v-icon>
																	<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
																</template>
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent99454"
																:color="item.myBillings?.percent99454 === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent99454 === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																<template>
																	<v-icon size="16" v-if="item.cptCode99454?.status === 1" color="black">
																		mdi-checkbox-blank
																	</v-icon>
																	<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
																</template>
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent99470"
																:color="item.myBillings?.percent99470 === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent99470 === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																{{ secToMinV2(item.myBillings?.seconds99470) }}
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent99457"
																:color="item.myBillings?.percent99457 === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent99457 === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																{{ secToMinV2(item.myBillings?.seconds99457) }}
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent994581st"
																:color="item.myBillings?.percent994581st === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent994581st === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																{{ secToMinV2(item.myBillings?.seconds994581st) }}
															</v-progress-linear>
														</td>
														<td>
															<v-progress-linear
																rounded
																:height="20"
																:value="item.myBillings?.percent994582nd"
																:color="item.myBillings?.percent994582nd === 100 ? 'green' : 'primary'"
																:class="item.myBillings?.percent994582nd === 100 ? 'white--text' : ''"
																background-color="blue-grey lighten-4"
																class="font-size12">
																{{ secToMinV2(item.myBillings?.seconds994582nd) }}
															</v-progress-linear>
														</td>
													</tr>
												</template>
											</v-data-table>
										</td>
									</template>
									<template #[`footer.prepend`]>
										<span class="font-weight-bold">
											{{ $t('patients') }}: {{ getTotalBillings(groupBillings(true, false)) }}
										</span>
									</template>
								</v-data-table>
								<v-data-table
									v-else
									:items="filterBillingsFromRepo()"
									item-key="patientData.id"
									class="data-table-outline"
									:headers="rpmPatientHeaders"
									fixed-header
									:items-per-page="-1"
									:no-data-text="$t('no-data-available')"
									:loading-text="$t('loading')"
									:height="pageHeight(-94)"
									dense>
									<template #item="{ item, index }">
										<tr
											:class="getRowsForDataTable(index)"
											@click="
												selectedBillingList = { billings: filterBillingsFromRepo() };
												selectedBillingIndex = index;
												showDetailsDialog = true;
											">
											<td class="text-left truncate-text" style="max-width: 200px !important">
												<v-icon
													class="mr-1 mdi"
													:class="
														item.patientData.isRpmEnabled ||
														item.patientData.isRtmEnabled ||
														item.patientData.isCcmEnabled
															? 'mdi-checkbox-blank'
															: 'mdi-checkbox-blank-outline'
													"
													color="primary" />
												<span class="table-font-size">
													{{ item.patientData.firstName }} {{ item.patientData.lastName }}
												</span>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.cptCode99453?.status === 1 ? 100 : 0"
													:color="item.cptCode99453?.status === 1 ? 'green' : 'primary'"
													:class="item.cptCode99453?.status === 1 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													<template>
														<v-icon size="16" v-if="item.cptCode99453?.status === 1" color="black">
															mdi-checkbox-blank
														</v-icon>
														<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
													</template>
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent99445"
													:color="item.myBillings?.percent99445 === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent99445 === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													<template>
														<v-icon size="16" v-if="item.cptCode99445?.status === 1" color="black">
															mdi-checkbox-blank
														</v-icon>
														<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
													</template>
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent99454"
													:color="item.myBillings?.percent99454 === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent99454 === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													<template>
														<v-icon size="16" v-if="item.cptCode99454?.status === 1" color="black">
															mdi-checkbox-blank
														</v-icon>
														<v-icon size="16" v-else color="black"> mdi-checkbox-blank-outline </v-icon>
													</template>
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent99470"
													:color="item.myBillings?.percent99470 === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent99470 === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.seconds99470) }}
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent99457"
													:color="item.myBillings?.percent99457 === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent99457 === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.seconds99457) }}
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent994581st"
													:color="item.myBillings?.percent994581st === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent994581st === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.seconds994581st) }}
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.percent994582nd"
													:color="item.myBillings?.percent994582nd === 100 ? 'green' : 'primary'"
													:class="item.myBillings?.percent994582nd === 100 ? 'white--text' : ''"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.seconds994582nd) }}
												</v-progress-linear>
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
				<v-expansion-panel>
					<v-expansion-panel-header style="height: 85px">
						<div>CCM</div>
						<div class="my-0 py-0">
							<v-row>
								<v-col class="d-flex justify-end align-center py-1 text-center" cols="12">
									<span class="d-flex align-start font-weight-bold font-size12-5">CPT</span>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt99437"
										:color="checkColor(billingSummary.cpt99437)">
										<div class="d-flex flex-column">
											<span>99437</span>
											<div>{{ billingSummary.cpt99437 }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt994391st"
										:color="checkColor(billingSummary.cpt994391st)">
										<div class="d-flex flex-column">
											<span>99439 1st</span>
											<div>{{ billingSummary.cpt994391st }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt994392nd"
										:color="checkColor(billingSummary.cpt994392nd)">
										<div class="d-flex flex-column">
											<span>99439 2nd</span>
											<div>{{ billingSummary.cpt994392nd }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12-5 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt99487"
										:color="checkColor(billingSummary.cpt99487)">
										<div class="d-flex flex-column">
											<span>99487</span>
											<div>{{ billingSummary.cpt99487 }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt99489"
										:color="checkColor(billingSummary.cpt99489)">
										<div class="d-flex flex-column">
											<span>99489</span>
											<div>{{ billingSummary.cpt99489 }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt99490"
										:color="checkColor(billingSummary.cpt99490)">
										<div class="d-flex flex-column">
											<span>99490</span>
											<div>{{ billingSummary.cpt99490 }}%</div>
										</div>
									</v-progress-circular>
									<v-progress-circular
										class="font-size12 mx-2 font-weight-bold"
										:rotate="-90"
										:size="75"
										:width="3"
										:value="billingSummary.cpt99491"
										:color="checkColor(billingSummary.cpt99491)">
										<div class="d-flex flex-column">
											<span>99491</span>
											<div>{{ billingSummary.cpt99491 }}%</div>
										</div>
									</v-progress-circular>
								</v-col>
							</v-row>
						</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<!-- CCM -->
						<v-row v-if="state === 'billing'" dense>
							<v-col class="px-0 pb-0" cols="12">
								<v-progress-linear :indeterminate="loading" v-if="loading" />
								<v-data-table
									v-if="['SYSTEM_ADMIN', 'SYSTEM_USER', 'ORGANIZATION_ADMIN'].includes(roleName)"
									:no-data-text="$t('no-data-available')"
									:loading-text="$t('loading')"
									:items="groupBillings(false, true)"
									item-key="hospitalId"
									:headers="ccmHospitalHeaders"
									fixed-header
									dense
									single-expand
									class="mx-0 px-0 data-table-outline"
									:height="pageHeight(-94)"
									:items-per-page="-1"
									:footer-props="getDataTableFooterProps()">
									<template #item="{ item, expand, isExpanded, index }">
										<tr
											:class="[getRowsForDataTable(index), { 'expanded-row': isExpanded }]"
											@click="expand(!isExpanded)">
											<td class="font-weight-bold" style="width: 350px">
												<div class="d-flex justify-space-between align-center">
													<span>{{ item.hospitalName }}</span>
													<v-chip class="white--text" pill x-small color="primary">
														{{ item.billings.length }}
													</v-chip>
												</div>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99437"
													:color="getHospitalSummary(item.hospitalId).percent99437 >= 100 ? 'green' : 'primary'"
													:class="{ 'white--text': getHospitalSummary(item.hospitalId).percent99437 >= 100 }"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99437 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent994391st"
													:color="getHospitalSummary(item.hospitalId).percent994391st >= 100 ? 'green' : 'primary'"
													:class="{
														'white--text': getHospitalSummary(item.hospitalId).percent994391st >= 100,
													}"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent994391st }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent994392nd"
													:color="getHospitalSummary(item.hospitalId).percent994392nd >= 100 ? 'green' : 'primary'"
													:class="{
														'white--text': getHospitalSummary(item.hospitalId).percent994392nd >= 100,
													}"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent994392nd }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99487"
													:color="getHospitalSummary(item.hospitalId).percent99487 >= 100 ? 'green' : 'primary'"
													:class="{
														'white--text': getHospitalSummary(item.hospitalId).percent99487 >= 100,
													}"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99487 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99489"
													:color="getHospitalSummary(item.hospitalId).percent99489 >= 100 ? 'green' : 'primary'"
													:class="{ 'white--text': getHospitalSummary(item.hospitalId).percent99489 >= 100 }"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99489 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99490"
													:color="getHospitalSummary(item.hospitalId).percent99490 >= 100 ? 'green' : 'primary'"
													:class="{
														'white--text': getHospitalSummary(item.hospitalId).percent99490 >= 100,
													}"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99490 }}%
												</v-progress-linear>
											</td>
											<td>
												<v-progress-linear
													v-if="getHospitalSummary(item.hospitalId)"
													class="font-weight-bold font-size12"
													:height="20"
													rounded
													:value="getHospitalSummary(item.hospitalId).percent99491"
													:color="getHospitalSummary(item.hospitalId).percent99491 >= 100 ? 'green' : 'primary'"
													:class="{ 'white--text': getHospitalSummary(item.hospitalId).percent99491 >= 100 }"
													background-color="blue-grey lighten-4">
													{{ getHospitalSummary(item.hospitalId).percent99491 }}%
												</v-progress-linear>
											</td>
											<td class="text-right px-2" style="width: 40px">
												<v-icon color="primary">
													{{ isExpanded ? 'mdi-menu-up' : 'mdi-menu-down' }}
												</v-icon>
											</td>
										</tr>
									</template>
									<template #expanded-item="{ item }">
										<tr style="cursor: default; background-color: #fff !important">
											<td class="pa-3 billings-border-bottom" colspan="9">
												<v-data-table
													:items="item.billings"
													item-key="patientData.id"
													class="data-table-outline"
													:headers="ccmPatientHeaders"
													single-expand
													fixed-header
													hide-default-footer
													:items-per-page="-1"
													:height="pageHeight(-174)"
													:no-data-text="$t('no-data-available')"
													:loading-text="$t('loading')"
													dense>
													<template #item="{ item, index }">
														<tr :class="getRowsForDataTable(index)">
															<td class="text-left" style="width: 200px">
																<v-icon
																	class="mr-1 mdi"
																	:class="
																		item.patientData.isRpmEnabled ||
																		item.patientData.isRtmEnabled ||
																		item.patientData.isCcmEnabled
																			? 'mdi-checkbox-blank'
																			: 'mdi-checkbox-blank-outline'
																	"
																	color="primary" />
																<span class="table-font-size">
																	{{ item.patientName }}
																</span>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99437"
																	:color="
																		item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99437 === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99437 === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings.ccmPhysicianCptCode.seconds99437) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st"
																	:color="
																		item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds994391st) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd"
																	:color="
																		item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds994392nd) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings.ccmComplexCptCode?.percent99487"
																	:color="
																		item.myBillings?.ccmBillings.ccmComplexCptCode?.percent99487 === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994387 === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings?.ccmComplexCptCode?.seconds99487) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings.ccmComplexCptCode.percent99489"
																	:color="
																		item.myBillings?.ccmBillings.ccmComplexCptCode.percent99489 === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99489 === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings.ccmComplexCptCode.seconds99489) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490"
																	:color="
																		item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490 === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490 === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds99490) }}
																</v-progress-linear>
															</td>
															<td class="px-2">
																<v-progress-linear
																	rounded
																	:height="20"
																	:value="item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99491"
																	:color="
																		item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99491 === 100
																			? 'green'
																			: 'primary'
																	"
																	:class="{
																		'white--text':
																			item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99489 === 100,
																	}"
																	background-color="blue-grey lighten-4"
																	class="font-size12">
																	{{ secToMinV2(item.myBillings?.ccmBillings.ccmPhysicianCptCode.seconds99491) }}
																</v-progress-linear>
															</td>
														</tr>
													</template>
												</v-data-table>
											</td>
										</tr>
									</template>
									<template #[`footer.prepend`]>
										<span class="font-weight-bold">
											{{ $t('patients') }}: {{ getTotalBillings(groupBillings(false, true)) }}
										</span>
									</template>
								</v-data-table>
								<v-data-table
									v-else
									:items="filterBillingsFromRepo(false, true)"
									item-key="patientData.id"
									class="data-table-outline"
									:headers="ccmPatientHeaders"
									single-expand
									fixed-header
									:items-per-page="-1"
									:height="pageHeight(-94)"
									:no-data-text="$t('no-data-available')"
									:loading-text="$t('loading')"
									dense>
									<template #item="{ item, index }">
										<tr :class="getRowsForDataTable(index)">
											<td class="text-left" style="width: 200px !important">
												<v-icon
													class="mr-1 mdi"
													:class="
														item.patientData.isRpmEnabled ||
														item.patientData.isRtmEnabled ||
														item.patientData.isCcmEnabled
															? 'mdi-checkbox-blank'
															: 'mdi-checkbox-blank-outline'
													"
													color="primary" />
												<span class="table-font-size">
													{{ item.patientData.firstName }} {{ item.patientData.lastName }}
												</span>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99437"
													:color="
														item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99437 === 100 ? 'green' : 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99437 === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings.ccmPhysicianCptCode.seconds99437) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st"
													:color="
														item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st === 100
															? 'green'
															: 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994391st === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds994391st) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd"
													:color="
														item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd === 100
															? 'green'
															: 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994392nd === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds994392nd) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings.ccmComplexCptCode?.percent99487"
													:color="
														item.myBillings?.ccmBillings.ccmComplexCptCode?.percent99487 === 100 ? 'green' : 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent994387 === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings?.ccmComplexCptCode?.seconds99487) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings.ccmComplexCptCode.percent99489"
													:color="
														item.myBillings?.ccmBillings.ccmComplexCptCode.percent99489 === 100 ? 'green' : 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99489 === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings.ccmComplexCptCode.seconds99489) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490"
													:color="
														item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490 === 100
															? 'green'
															: 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99490 === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.seconds99490) }}
												</v-progress-linear>
											</td>
											<td class="px-2">
												<v-progress-linear
													rounded
													:height="20"
													:value="item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99491"
													:color="
														item.myBillings?.ccmBillings.ccmPhysicianCptCode.percent99491 === 100 ? 'green' : 'primary'
													"
													:class="{
														'white--text': item.myBillings?.ccmBillings?.ccmNonComplexCptCode?.percent99489 === 100,
													}"
													background-color="blue-grey lighten-4"
													class="font-size12">
													{{ secToMinV2(item.myBillings?.ccmBillings.ccmPhysicianCptCode.seconds99491) }}
												</v-progress-linear>
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<div class="text-right px-2">
				<v-btn @click="openCalculator()" :disabled="loading" color="primary2" style="color: white" elevation="0">
					{{ $t('reimbursement-calculator') }}
				</v-btn>
			</div>
		</div>
		<DetailsCard
			:dialog.sync="showDetailsDialog"
			v-if="showDetailsDialog && selectedBillingIndex !== -1"
			:item="selectedBillingList.billings[selectedBillingIndex]"
			@previousPerson="
				selectedBillingIndex > 0
					? selectedBillingIndex--
					: (selectedBillingIndex = selectedBillingList.billings.length - 1)
			"
			@nextPerson="
				selectedBillingIndex < selectedBillingList.billings.length - 1
					? selectedBillingIndex++
					: (selectedBillingIndex = 0)
			"
			@closeDialog="
				showDetailsDialog = false;
				selectedBillingIndex = -1;
			" />
		<v-dialog
			v-if="calculatorDialog"
			v-model="calculatorDialog"
			width="900px"
			transition="dialog-top-transition"
			persistent>
			<v-card height="90vh">
				<v-card-title color="primary2" class="text-left card-header pa-4">
					<v-row no-gutters class="align-center">
						<v-col cols="10">{{ $t('reimbursement-calculator') }}</v-col>
						<v-spacer />
						<v-icon @click="closeCalculatorDialog()" color="white">mdi-close</v-icon>
					</v-row>
				</v-card-title>
				<v-card-text class="pa-0 overflow-y-hidden" style="height: calc(100% - 64px)">
					<iframe v-if="calculatorUrl" :src="calculatorUrl" width="100%" height="100%" style="border: none" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
	<div v-else-if="state === 'email'">
		<BillingReports />
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DetailsCard from '../components/BillingDetailsCard.vue';
import { billWhite } from '@/assets';
import { getDataTableFooterProps, getRowsForDataTable, showErrorAlert, showSuccessAlert } from '@/utils/utilities';
import { aggregateData } from '@/utils/aggregateData';
import BillingReports from '../components/BillingReports.vue';

export default {
	components: {
		BillingReports,
		DetailsCard,
	},
	data () {
		return {
			state: 'billing',
			loading: false,
			search: '',
			date: new Date().toISOString().substr(0, 7),
			invoice: billWhite,
			billingSummary: {
				cpt99453: 0,
				cpt99445: 0,
				cpt99454: 0,
				cpt99470: 0,
				cpt99457: 0,
				cpt994581st: 0,
				cpt994582nd: 0,
				cpt99490: 0,
				cpt994391st: 0,
				cpt994392nd: 0,
				cpt99487: 0,
				cpt99489: 0,
				cpt99491: 0,
				cpt99437: 0,
				cpt99453Count: 0,
				cpt99445Count: 0,
				cpt99454Count: 0,
				cpt99470Count: 0,
				cpt99457Count: 0,
				cpt994581stCount: 0,
				cpt994582ndCount: 0,
				cpt99490Count: 0,
				cpt994391stCount: 0,
				cpt994392ndCount: 0,
				cpt99487Count: 0,
				cpt99489Count: 0,
				cpt99491Count: 0,
				cpt99437Count: 0,
			},
			hospitalData: [],
			headersCCM: [],
			expandedPanels: [],
			headers: [
				{ text: 'ID', value: 'id' },
				{ text: 'Name', value: 'name' },
			],
			items: [
				{ id: 1, name: 'Apple', category: 'Fruits' },
				{ id: 2, name: 'Banana', category: 'Fruits' },
				{ id: 3, name: 'Carrot', category: 'Vegetables' },
				{ id: 4, name: 'Potato', category: 'Vegetables' },
			],
			expandedGroups: [], // empty by default → all collapsed
			showDetailsDialog: false,
			selectedBillingList: [],
			selectedBillingIndex: -1,
			calculatorUrl: null,
			calculatorDialog: false,
		};
	},
	computed: {
		...mapState({
			billingsFromRepo: (state) => state.billings.billingSummaryForMonth,
			loggedUser: (state) => state.authentication.userData,
			authUserData: (state) => state.authentication.userData,
			generatedCsvFile: (state) => state.billings.generatedCsvFile,
			billingReportState: (state) => state.filterbar.billingReportState,
		}),
		...mapGetters({
			roleName: 'authentication/getRole',
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
			appBarBillingDate: 'filterbar/getBillingDate',
			appBarBillingDataForHospitalAdmin: 'filterbar/getBillingDataForHospitalAdmin',
			appBarBillingDataOrganizationalAdmin: 'filterbar/getBillingDataOrganizational',
			appBarBillingCsv: 'filterbar/getBillingCsv',
			appBarBillingTypeFilterVerifier: 'filterbar/getRpmValue',
		}),
		rpmHospitalHeaders () {
			return [
				{ text: this.$t('hospital-name'), value: 'patientName', align: 'start', width: 250 },
				{ text: '99453', value: '', sortable: false, align: 'center' },
				{ text: '99445', value: '', sortable: false, align: 'center' },
				{ text: '99454', value: '', sortable: false, align: 'center' },
				{ text: '99470', value: '', sortable: false, align: 'center' },
				{ text: '99457', value: '', sortable: false, align: 'center' },
				{ text: '99458 1st', value: '', sortable: false, align: 'center' },
				{ text: '99458 2nd', value: '', sortable: false, align: 'center' },
				{ text: '', value: '', sortable: false },
			];
		},
		rpmPatientHeaders () {
			return [
				{ text: this.$t('patient-name'), value: 'patientName', align: 'start', width: 250 },
				{ text: '99453', value: '', sortable: false, align: 'center' },
				{ text: '99445', value: '', sortable: false, align: 'center' },
				{ text: '99454', value: '', sortable: false, align: 'center' },
				{ text: '99470', value: '', sortable: false, align: 'center' },
				{ text: '99457', value: '', sortable: false, align: 'center' },
				{ text: '99458 1st', value: '', sortable: false, align: 'center' },
				{ text: '99458 2nd', value: '', sortable: false, align: 'center' },
			];
		},
		ccmHospitalHeaders () {
			return [
				{ text: this.$t('hospital-name'), value: 'patientName', align: 'start' },
				{ text: '99437', value: '', sortable: false, align: 'center' },
				{ text: '99439 1st', value: '', sortable: false, align: 'center' },
				{ text: '99439 2nd', value: '', sortable: false, align: 'center' },
				{ text: '99487', value: '', sortable: false, align: 'center' },
				{ text: '99489', value: '', sortable: false, align: 'center' },
				{ text: '99490', value: '', sortable: false, align: 'center' },
				{ text: '99491', value: '', sortable: false, align: 'center' },
				{ text: '', value: '', sortable: false },
			];
		},
		ccmPatientHeaders () {
			return [
				{ text: this.$t('patient-name'), value: 'patientName', align: 'start' },
				{ text: '99437', value: '', sortable: false, align: 'center' },
				{ text: '99439 1st', value: '', sortable: false, align: 'center' },
				{ text: '99439 2nd', value: '', sortable: false, align: 'center' },
				{ text: '99487', value: '', sortable: false, align: 'center' },
				{ text: '99489', value: '', sortable: false, align: 'center' },
				{ text: '99490', value: '', sortable: false, align: 'center' },
				{ text: '99491', value: '', sortable: false, align: 'center' },
			];
		},
	},
	watch: {
		billingReportState (val) {
			this.state = val;
		},
		date (val) {
			const month = val.slice(-2);
			this.initialize({
				month: month.charAt(0) === '0' ? month.charAt(1) : parseInt(month),
				year: parseInt(val.substring(0, 4)),
			});
		},
		async appBarBillingDate (val) {
			// after filtering
			if (val !== null && val !== undefined) {
				const monthExtarcted = parseInt(val.slice(-2));
				const yearExtarcted = parseInt(val.substring(0, 4));

				await this.initialize({
					month: monthExtarcted,
					year: yearExtarcted,
				});
			}
		},
		appBarBillingDataForHospitalAdmin (val) {
			this.generateBillingDataForHospitalAdmin(val.hospitalId);
		},
		appBarBillingDataOrganizationalAdmin (val) {
			this.generateBillingDataForOrganizationalAdmin(val);
		},
		appBarBillingCsv (val) {
			this.generateCSV(val);
		},
	},
	async mounted () {
		await this.initialize({
			month: parseInt(this.date.substring(5, 7)),
			year: parseInt(this.date.substring(0, 4)),
		});
	},
	methods: {
		toggleGroup (groupName) {
			if (this.expandedGroups.includes(groupName)) {
				this.expandedGroups = this.expandedGroups.filter((g) => g !== groupName);
			} else {
				this.expandedGroups.push(groupName);
			}
		},
		isGroupOpen (groupName) {
			return this.expandedGroups.includes(groupName);
		},
		getRowsForDataTable,
		getDataTableFooterProps,
		openCalculator () {
			var url = 'https://www.wellnessmetric.net/embedded-calculator/?rrc_achieved=';
			if (this.billingSummary.cpt99453Count > 0) {
				url += `99453:${this.billingSummary.cpt99453Count},`;
			}
			if (this.billingSummary.cpt99445Count > 0) {
				url += `99445:${this.billingSummary.cpt99445Count},`;
			}
			if (this.billingSummary.cpt99454Count > 0) {
				url += `99454:${this.billingSummary.cpt99454Count},`;
			}
			if (this.billingSummary.cpt99470Count > 0) {
				url += `99470:${this.billingSummary.cpt99470Count},`;
			}
			if (this.billingSummary.cpt99457Count > 0) {
				url += `99457:${this.billingSummary.cpt99457Count},`;
			}
			if (this.billingSummary.cpt994581stCount > 0 || this.billingSummary.cpt994582ndCount > 0) {
				url += `99458:${this.billingSummary.cpt994581stCount + this.billingSummary.cpt994582ndCount},`;
			}
			if (this.billingSummary.cpt99490Count > 0) {
				url += `99490:${this.billingSummary.cpt99490Count},`;
			}
			if (this.billingSummary.cpt994391stCount > 0 || this.billingSummary.cpt994392ndCount > 0) {
				url += `99490:${this.billingSummary.cpt994391stCount + this.billingSummary.cpt994392ndCount},`;
			}
			if (this.billingSummary.cpt99487Count > 0) {
				url += `99487:${this.billingSummary.cpt99487Count},`;
			}
			if (this.billingSummary.cpt99489Count > 0) {
				url += `99489:${this.billingSummary.cpt99489Count},`;
			}
			if (this.billingSummary.cpt99491Count > 0) {
				url += `99491:${this.billingSummary.cpt99491Count},`;
			}
			if (this.billingSummary.cpt99437Count > 0) {
				url += `99437:${this.billingSummary.cpt99437Count},`;
			}
			this.calculatorUrl = url;
			this.calculatorDialog = true;
		},
		closeCalculatorDialog () {
			this.calculatorDialog = false;
			this.calculatorUrl = null;
		},
		filterBillingsFromRepo (isRpm = true, isCcm = false) {
			const searchTerm = this.appBarSearch ? this.appBarSearch.toLowerCase() : '';
			let filteredBillings = this.billingsFromRepo.map((item) => ({
				patientName: `${item.patientData.firstName} ${item.patientData.lastName}`,
				...item,
			}));
			filteredBillings = filteredBillings.filter((item) => {
				const patientName = `${item.patientData.firstName} ${item.patientData.lastName}`.toLowerCase();
				const hospital = item.hospitalData?.hospitalName.toLowerCase();

				return patientName.includes(searchTerm) || hospital.includes(searchTerm);
			});

			// // Filter based on RPM status
			// if (this.loggedUser.isSequoiaUser === false || this.loggedUser.isSequoiaUser === null) {
			// 	// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			// 	this.loading = false;
			// 	return filteredBillings;
			// }
			if (this.appBarBillingTypeFilterVerifier === 1) {
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.loading = false;
				return filteredBillings;
			}
			if (this.appBarBillingTypeFilterVerifier === 0 && isRpm) {
				filteredBillings = filteredBillings.filter(
					(item) =>
						item.patientData &&
						(item.patientData.isRpmEnabled === true ||
							item.patientData.isRtmEnabled ||
							item.patientData.isCcmEnabled !== true),
				);
			}

			if (this.appBarBillingTypeFilterVerifier === 0 && isCcm) {
				filteredBillings = filteredBillings.filter(
					(item) =>
						item.patientData &&
						(item.patientData.isRpmEnabled !== true ||
							item.patientData.isRtmEnabled ||
							item.patientData.isCcmEnabled === true),
				);
			}
			return filteredBillings;
		},

		groupBillings (isRpm = true, isCcm = false) {
			const billings = this.filterBillingsFromRepo(isRpm, isCcm);
			return billings.reduce((acc, billing) => {
				const { hospitalData, hospitalId, ...rest } = billing;
				let grp = acc.find((g) => g.hospitalId === hospitalId);
				if (!grp) {
					grp = { hospitalName: hospitalData.hospitalName, hospitalId, billings: [] };
					acc.push(grp);
				}
				grp.billings.push({
					hospitalData,
					hospitalId,
					...rest,
				});
				return acc;
			}, []);
		},

		resetLocalProperties () {
			this.billingSummary = {
				cpt99453: 0,
				cpt99445: 0,
				cpt99454: 0,
				cpt99470: 0,
				cpt99457: 0,
				cpt994581st: 0,
				cpt994582nd: 0,
				cpt99490: 0,
				cpt994391st: 0,
				cpt994392nd: 0,
				cpt99487: 0,
				cpt99489: 0,
				cpt99491: 0,
				cpt99437: 0,
				cpt99453Count: 0,
				cpt99445Count: 0,
				cpt99454Count: 0,
				cpt99470Count: 0,
				cpt99457Count: 0,
				cpt994581stCount: 0,
				cpt994582ndCount: 0,
				cpt99490Count: 0,
				cpt994391stCount: 0,
				cpt994392ndCount: 0,
				cpt99487Count: 0,
				cpt99489Count: 0,
				cpt99491Count: 0,
				cpt99437Count: 0,
			};
			this.hospitalData = [];
		},
		getHospitalSummary (hospitalId) {
			// Check if the ID exists in the aggregatedData
			if (hospitalId in this.hospitalData) {
				// Return the aggregated data for the specified ID
				return this.hospitalData[hospitalId];
			} else {
				// Return null or handle the case when the ID is not found
				return null;
			}
		},
		async getMedicalInstitutions () {
			this.loading = true;
			await this.$store.dispatch('medicalInstitutions/getMedicalInstitutions').then(() => {
				// this.medicalInstitutions = this.medicalInstitutionsFromRepo;
				this.loading = false;
			});
		},
		async generateCSV (paramBody) {
			const year = paramBody.selectedYear;
			const month = paramBody.selectedMonth;
			const currentYear = new Date().getFullYear();
			const currentMonth = new Date().getMonth() + 1;

			const selectedYear = year;
			const selectedMonth = month;
			var clientName = paramBody.clientName;
			var clientId = paramBody.clientId;

			if (selectedYear > currentYear || (selectedYear === currentYear && selectedMonth > currentMonth)) {
				showErrorAlert(this.$t('cant-download-csv-for-upcoming-months'));
				return;
			}

			if (this.roleName !== 'ORGANIZATION_ADMIN') {
				clientName = this.authUserData.hospitalAssignedData.hospitalName;
				clientId = this.authUserData.hospitalAssignedData.id;

				const hospitalData = { hospitalId: clientId, month: selectedMonth, year: selectedYear };
				await this.$store.dispatch('billings/generateCsvHospitalPatientsForMonth', hospitalData).then((res) => {
					showSuccessAlert(this.$t('csv-downloaded'));
					const url = window.URL.createObjectURL(new Blob([this.generatedCsvFile.data]));
					const link = document.createElement('a');
					// const csvFileName = `cpt-billings-summary-for-${clientName}-${selectedYear}-${selectedMonth}-csv.csv`;
					const csvFileName = `cpt-billings-summary-for-${clientName}-${selectedYear}-${selectedMonth}-csv.zip`; // Updated to reflect zipped file
					link.href = url;
					link.setAttribute('download', csvFileName);
					document.body.appendChild(link);
					link.click();
				});
			} else {
				clientName = this.authUserData.organizationAssignedData.institutionName;
				clientId = this.authUserData.organizationAssignedData.id;

				const organizationData = { organizationId: clientId, month: selectedMonth, year: selectedYear };
				await this.$store.dispatch('billings/generateCsvOrganizationPatientsForMonth', organizationData).then((res) => {
					showSuccessAlert(this.$t('csv-downloaded'));
					const url = window.URL.createObjectURL(new Blob([this.generatedCsvFile.data]));
					const link = document.createElement('a');
					// const csvFileName = `cpt-billings-summary-for-${clientName}-${selectedYear}-${selectedMonth}-csv.csv`;
					const csvFileName = `cpt-billings-summary-for-${clientName}-${selectedYear}-${selectedMonth}-csv.zip`; // Updated to reflect zipped file
					link.href = url;
					link.setAttribute('download', csvFileName);
					document.body.appendChild(link);
					link.click();
				});
			}
		},
		checkColor (value) {
			if (value >= 0 && value <= 25) {
				return 'red';
			}
			if (value > 25 && value <= 50) {
				return 'orange';
			}
			if (value > 50 && value <= 75) {
				return 'blue';
			}
			if (value > 75 && value <= 95) {
				return 'teal';
			}
			if (value > 95 && value <= 100) {
				return 'green';
			}
		},
		secToMinV2 (seconds) {
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const remainingSeconds = seconds % 60;

			return `${hours > 0 ? hours + 'h ' : ''}${minutes > 0 ? minutes + 'm ' : ''}${remainingSeconds}s`;
		},
		closeAll () {
			Object.keys(this.$refs).forEach((k) => {
				if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
					this.$refs[k].$el.click();
				}
			});
		},
		async generateBillingDataForHospitalAdmin (item) {
			const month =
				this.appBarBillingDate !== null ? this.appBarBillingDate.substring(5, 7) : this.date.substring(5, 7);
			const year = this.appBarBillingDate !== null ? this.appBarBillingDate.substring(0, 4) : this.date.substring(0, 4);

			const dataForBilling = {
				hospitalId: item,
				month: parseInt(month),
				year: parseInt(year),
			};

			this.$store.dispatch('billings/generateforallhospitalpatientsformonth', dataForBilling).then(() => {
				return this.initialize(dataForBilling);
			});
		},
		async generateBillingDataForOrganizationalAdmin (item) {
			const month =
				this.appBarBillingDate !== null ? this.appBarBillingDate.substring(5, 7) : this.date.substring(5, 7);
			const year = this.appBarBillingDate !== null ? this.appBarBillingDate.substring(0, 4) : this.date.substring(0, 4);

			const dataForBillingOrganizationAdmin = {
				organizationId: this.authUserData.organizationId,
				month: parseInt(month),
				year: parseInt(year),
			};

			await this.$store.dispatch(
				'billings/generateforallorganizationpatientsformonth',
				dataForBillingOrganizationAdmin,
			);
			await this.initialize(dataForBillingOrganizationAdmin);
		},
		async initialize (object) {
			this.resetLocalProperties();
			this.loading = true;
			if (this.roleName === 'ORGANIZATION_ADMIN') {
				const headers = {
					organizationId: this.authUserData.organizationId,
					month: object.month,
					year: object.year,
				};
				await this.$store.dispatch('billings/getbillingsummaryforallpatientsformonth', headers);
			} else {
				const headers = {
					hospitalId: this.loggedUser?.hospitalAssignedData?.id,
					month: object.month,
					year: object.year,
				};
				await this.$store.dispatch('billings/getbillingsummaryforallpatientsformonth', headers);
			}
			this.billingSummary.cpt99453 = 0;
			this.billingSummary.cpt99444 = 0;
			this.billingSummary.cpt99454 = 0;
			this.billingSummary.cpt99470 = 0;
			this.billingSummary.cpt99457 = 0;
			this.billingSummary.cpt994581st = 0;
			this.billingSummary.cpt994582nd = 0;

			this.billingSummary.cpt99490 = 0;
			this.billingSummary.cpt994391st = 0;
			this.billingSummary.cpt994392nd = 0;

			this.billingSummary.cpt99487 = 0;
			this.billingSummary.cpt99489 = 0;

			this.billingSummary.cpt99491 = 0;
			this.billingSummary.cpt99437 = 0;

			this.billingSummary.cpt99453Count = 0;
			this.billingSummary.cpt99444Count = 0;
			this.billingSummary.cpt99454Count = 0;
			this.billingSummary.cpt99470Count = 0;
			this.billingSummary.cpt99457Count = 0;
			this.billingSummary.cpt994581stCount = 0;
			this.billingSummary.cpt994582ndCount = 0;

			this.billingSummary.cpt99490Count = 0;
			this.billingSummary.cpt994391stCount = 0;
			this.billingSummary.cpt994392ndCount = 0;

			this.billingSummary.cpt99487Count = 0;
			this.billingSummary.cpt99489Count = 0;

			this.billingSummary.cpt99491Count = 0;
			this.billingSummary.cpt99437Count = 0;

			this.billingSummary.rpmPatientCount = 0;
			this.billingSummary.rtmPatientCount = 0;
			this.billingSummary.ccmPatientCount = 0;

			this.billingsFromRepo.forEach((patient, index) => {
				if (patient.patientData.isRpmEnabled === true) this.billingSummary.rpmPatientCount++;
				if (patient.patientData.isRtmEnabled === true) this.billingSummary.rtmPatientCount++;
				if (patient.patientData.isCcmEnabled === true) this.billingSummary.ccmPatientCount++;

				const codes = patient?.groupedCcmBillingCodes;

				codes?.cptCode99490?.status === 1 && this.billingSummary.cpt99490Count++;
				codes?.cptCode99439First?.status === 1 && this.billingSummary.cpt994391stCount++;
				codes?.cptCode99439Second?.status === 1 && this.billingSummary.cpt994392ndCount++;
				codes?.cptCode99487?.status === 1 && this.billingSummary.cpt99487Count++;
				codes?.cptCode99489?.status === 1 && this.billingSummary.cpt99489Count++;
				codes?.cptCode99491?.status === 1 && this.billingSummary.cpt99491Count++;
				codes?.cptCode99437?.status === 1 && this.billingSummary.cpt99437Count++;

				if (patient.cptCode99453?.status === 1) {
					this.billingSummary.cpt99453Count++;
				}
				if (patient.cptCode99445?.status === 1) {
					this.billingSummary.cpt99445Count++;
				}
				if (patient.cptCode99454?.status === 1) {
					this.billingSummary.cpt99454Count++;
				}
				if (patient.cptCode99470?.status === 1) {
					this.billingSummary.cpt99470Count++;
				}
				if (patient.cptCode99457?.status === 1) {
					this.billingSummary.cpt99457Count++;
				}
				if (patient.cptCode99458First?.status === 1) {
					this.billingSummary.cpt994581stCount++;
				}
				if (patient.cptCode99458Second?.status === 1) {
					this.billingSummary.cpt994582ndCount++;
				}
			});
			this.billingSummary.cpt99453 =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt99453Count / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99445 =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt99445Count / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99454 =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt99454Count / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99470 =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt99470Count / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99457 =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt99457Count / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt994581st =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt994581stCount / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt994582nd =
				this.billingSummary.rpmPatientCount > 0
					? ((this.billingSummary.cpt994582ndCount / this.billingSummary.rpmPatientCount) * 100).toFixed(0)
					: 0;

			this.billingSummary.cpt99490 =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt99490Count / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt994391st =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt994391stCount / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt994392nd =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt994392ndCount / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99487 =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt99487Count / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99489 =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt99489Count / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99491 =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt99491Count / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.billingSummary.cpt99437 =
				this.billingSummary.ccmPatientCount > 0
					? ((this.billingSummary.cpt99437Count / this.billingSummary.ccmPatientCount) * 100).toFixed(0)
					: 0;
			this.loading = false;
			this.hospitalData = aggregateData(this.billingsFromRepo);
			this.closeAll();
		},

		/**
		 * Convert a duration in seconds into a human-readable string.
		 * @param {number} totalSeconds — the total number of seconds
		 * @returns {string} e.g. "1 day, 2 hours, 3 minutes, 4 seconds"
		 */
		formatDuration (totalSeconds) {
			const units = [
				{ label: 'day', seconds: 86400 },
				{ label: 'hour', seconds: 3600 },
				{ label: 'minute', seconds: 60 },
				{ label: 'second', seconds: 1 },
			];

			let remaining = totalSeconds;
			const parts = [];

			for (const { label, seconds } of units) {
				const amount = Math.floor(remaining / seconds);
				if (amount > 0) {
					parts.push(`${amount} ${label}${amount !== 1 ? 's' : ''}`);
					remaining %= seconds;
				}
			}

			// If all units were zero, show “0 seconds”
			return parts.length > 0 ? parts.join(', ') : '0 seconds';
		},

		getTotalBillings (group) {
			let length = 0;
			group.forEach((item) => {
				length += item.billings.length;
			});
			return length;
		},
	},
};
</script>
